import { Navigate, Outlet } from "react-router-dom";
import {
  GET_LOCAL_STORAGE,
  LOCAL_STORAGE_KEY,
} from "../../helpers/localStorage";

const PrivateRoutesAuth = () => {
  var cookieValue =
    GET_LOCAL_STORAGE(LOCAL_STORAGE_KEY.cognitoIdentity) &&
    GET_LOCAL_STORAGE(LOCAL_STORAGE_KEY.selectedRole);
  if (!cookieValue) return <Navigate to="/sign-in" />;
  return <Outlet />;
};

export default PrivateRoutesAuth;
